import React, { useEffect, useRef, useState } from 'react'

export const useInterval = (ms = 500) => {
  const [now, setNow] = useState(Date.now())
  const timer = useRef<any>(null)
  useEffect(() => {
    return () => clearInterval(timer.current)
  }, [])
  useEffect(() => {
    clearInterval(timer.current)
    timer.current = setInterval(() => {
      setNow(Date.now())
    }, ms)
  }, [ms])
  return now
}